import type { ComponentChildren } from 'preact';

export function Field(props: {
  label: string;
  error?: string | undefined;
  children: ComponentChildren;
  for?: string;
}) {
  return (
    <div class={props.error ? 'field bad' : 'field'}>
      <label for={props.for}>{props.label}</label>
      {props.children}
      {props.error ? <div class="err">{props.error}</div> : null}
    </div>
  );
}
